import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 20px 0px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const AdditionalsGroupCard = styled.div`
  width: 100%;
  border: 1px solid ${props => props.selected ?
    props.theme.colors.primary : props.theme.colors.backgroundSecondary};
  padding: 10px;
  border-radius: 10px;
`;

export const AdditionalGroupCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const AdditionalGroupTitle = styled.h5`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${({ theme, selected }) =>
    selected ? theme.colors.primary : theme.colors.text};
  flex: 1;
  padding: 6px 0%;
  cursor: pointer;
`;

export const AdditionalGroupStatus = styled.div`
  color: ${({ theme, active }) => (active ? theme.colors.success : theme.colors.danger)};
  border: 1px solid ${({ theme, active }) => (active ? theme.colors.success : theme.colors.danger)};
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const AdditionalGroupCardContent = styled.div`
  display: flex;
  flex-direction: column;
  max-height: ${({ expanded }) => (expanded ? '50vh' : '0px')};
  overflow: ${({ expanded }) => (expanded ? 'auto' : 'hidden')};
  opacity: ${({ expanded }) => (expanded ? 1 : 0)};
  margin-top: ${({ expanded }) => (expanded ? '10px' : '0px')};
  padding-left: 30px;

  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
`;

export const AdditionalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 6px 4px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.backgroundSecondary};

  &:last-child {
    border-bottom: none;
  }
`;

export const AdditionalInfo = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex: 1;
  cursor: pointer;
  min-width: 0;
`;

export const AdditionalRowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const AdditionalTitle = styled.p`
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AdditionalPrice = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 13px;
  margin: 0;
  white-space: nowrap;
`;
